const cards = [
  {
    title: '海量影视资源库',
    desc: '涵盖电影、电视剧、综艺、动漫、纪录片等多类型内容，片源每日实时更新，热门新片第一时间上架，满足不同用户的观影口味与需求。',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=A%20spacious%20modern%20digital%20media%20library%20with%20floating%20colorful%20film%20posters%20arranged%20in%20a%20tidy%20grid%2C%20warm%20ambient%20lighting%2C%20minimalist%20interior%20design%2C%20wooden%20shelves%20with%20movie%20collections%2C%20cinematic%20atmosphere%2C%20warm%20gold%20and%20cream%20color%20palette%2C%20editorial%20photography%20style&width=640&height=400&seq=cards-library-01&orientation=landscape',
  },
  {
    title: '高清画质畅快体验',
    desc: '支持1080P、4K超清画质播放，自适应网络带宽智能切换清晰度。采用先进视频编码技术，低流量也能流畅观看，看片不卡顿不缓冲。',
    icon: 'ri-4k-line',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20large%20flat%20screen%20TV%20displaying%20a%20crystal%20clear%20cinematic%204K%20movie%20scene%20with%20vibrant%20colors%2C%20living%20room%20setting%20with%20warm%20cozy%20atmosphere%2C%20soft%20ambient%20lighting%2C%20premium%20home%20theater%20experience%2C%20high%20contrast%20visuals%2C%20warm%20neutral%20color%20tone&width=640&height=400&seq=cards-quality-02&orientation=landscape',
  },
  {
    title: '离线下载随时随地看',
    desc: '支持视频离线缓存下载，Wi-Fi环境下提前下载好想看的影片，出门在外无需流量也能畅快追剧，地铁、飞机、旅途中的观影好伴侣。',
    icon: 'ri-download-cloud-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20download%20progress%20screen%20for%20movies%20in%20a%20modern%20app%20interface%2C%20placed%20on%20a%20cozy%20wooden%20coffee%20table%20with%20a%20warm%20drink%20nearby%2C%20morning%20natural%20light%20streaming%20in%2C%20comfortable%20lifestyle%20scene%2C%20warm%20cream%20and%20gold%20tones&width=640&height=400&seq=cards-offline-03&orientation=landscape',
  },
  {
    title: '多端同步无缝切换',
    desc: '一个账号多设备通用，手机、平板、电视盒子均可安装使用。观看记录云端同步，换个设备继续追剧，进度自动保存不丢失，观影体验不间断。',
    icon: 'ri-device-line',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20smart%20devices%20including%20smartphone%2C%20tablet%20and%20smart%20TV%20all%20displaying%20the%20same%20movie%20streaming%20interface%20with%20synchronized%20content%2C%20arranged%20on%20a%20clean%20modern%20desk%2C%20warm%20minimalist%20setup%2C%20soft%20natural%20daylight%2C%20cohesive%20warm%20aesthetic&width=640&height=400&seq=cards-sync-04&orientation=landscape',
  },
  {
    title: '完全免费无需会员',
    desc: '91影视看片app坚持免费模式，无需注册会员即可观看全部内容。无隐藏收费、无强制广告弹窗，真正实现打开即看的纯粹观影体验。',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=A%20happy%20person%20relaxing%20on%20a%20comfortable%20sofa%20watching%20an%20entertaining%20movie%20on%20a%20large%20screen%20in%20a%20bright%20modern%20living%20room%2C%20carefree%20leisure%20time%2C%20warm%20sunlight%20through%20windows%2C%20cozy%20interior%20with%20plants%2C%20lifestyle%20photography%2C%20warm%20neutral%20tones&width=640&height=400&seq=cards-free-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">全方位了解91影视看片app的强大功能，从资源覆盖到播放体验，每一项都为您精心打造</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={`91影视看片app - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                    <i className={`${card.icon} text-sm`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900">{card.title}</h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}